import {
  ClipboardList,
  Newspaper,
  CircleUser,
  MessagesSquare,
  Info,
} from 'lucide-react'
import SEO from '@/components/shared/SEO'
import ClaimUpdatesHero from '@/components/claim-updates/ClaimUpdatesHero'
import UpdateSectionCard from '@/components/claim-updates/UpdateSectionCard'
import WorkChecklist from '@/components/claim-updates/WorkChecklist'
import NewThisMonthCallout from '@/components/claim-updates/NewThisMonthCallout'
import FcaTimeline from '@/components/claim-updates/FcaTimeline'
import QuickLinksCard from '@/components/claim-updates/QuickLinksCard'
import UpdateDetailsCta from '@/components/claim-updates/UpdateDetailsCta'
import { monthlyClaimUpdateData } from '@/components/claim-updates/monthlyClaimUpdateData'
import { fcaTimelineData } from '@/components/claim-updates/fcaTimelineData'

const ClaimUpdatesPage = () => {
  const {
    lastUpdated,
    claimUpdate,
    latestIndustryNews,
    whatThisMeansForYou,
    hearFromYourLender,
    stayingInformed,
    newThisMonth,
  } = monthlyClaimUpdateData

  return (
    <div className="flex-1 bg-gray-50">
      <SEO
        title="Car Finance Claim Updates | Claims1"
        description="Read the latest update about your car finance claim, FCA developments and what they mean for you."
        url="/claim-updates"
        schemaType="WebPage"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Claim Updates', url: '/claim-updates' },
        ]}
      />

      <ClaimUpdatesHero lastUpdated={lastUpdated} />

      <div className="container mx-auto max-w-6xl px-4 py-8 sm:py-10">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_340px] lg:items-start lg:gap-8">
          {/* Main column */}
          <div className="flex flex-col gap-4 sm:gap-5">
            <UpdateSectionCard
              icon={ClipboardList}
              heading={claimUpdate.heading}
              content={claimUpdate.content}
            />
            <UpdateSectionCard
              icon={Newspaper}
              heading={latestIndustryNews.heading}
              content={latestIndustryNews.content}
            />
            <UpdateSectionCard
              icon={CircleUser}
              heading={whatThisMeansForYou.heading}
              content={whatThisMeansForYou.content}
            />
            <UpdateSectionCard
              icon={MessagesSquare}
              heading={hearFromYourLender.heading}
              content={hearFromYourLender.content}
            />
            <WorkChecklist />
            <UpdateSectionCard
              icon={Info}
              heading={stayingInformed.heading}
              content={stayingInformed.content}
            />
            <UpdateDetailsCta />
          </div>

          {/* Sidebar on desktop, stacks below main content on mobile */}
          <div className="flex flex-col gap-4 sm:gap-5">
            <NewThisMonthCallout newThisMonth={newThisMonth} />

            <div
              id="fca-timeline"
              className="border-foreground/15 scroll-mt-4 overflow-hidden rounded-2xl border bg-white"
            >
              <div className="bg-foreground px-5 py-3">
                <h2 className="text-sm font-bold tracking-wider text-white uppercase">
                  FCA News Timeline
                </h2>
              </div>

              <div className="p-4 sm:p-5">
                <FcaTimeline items={fcaTimelineData} />
              </div>
            </div>

            <QuickLinksCard />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClaimUpdatesPage
